export default {
      id: "ic_mail-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_mail-usage",
      toString: function () {
        return this.url;
      }
    }